import React, { createContext, useContext, useReducer } from 'react';
import { locale, loadMessages } from "devextreme/localization";
import trMessages from "devextreme/localization/messages/tr.json";

loadMessages(trMessages);
loadMessages(window.__APP__.messages);
locale(window.__APP__.locale);
const AppStateContext = createContext();

const initialState = {...window.__APP__};

const reducer = (state, action) => {
    switch(action.type) {
        case "SHOW_CAPTCHA":
            return {...state, showCaptcha: true}
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}

export const AppStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <AppStateContext.Provider value={{state, dispatch}}>
            {children}
        </AppStateContext.Provider>
    )
}

export const useAppState = () => useContext(AppStateContext);